import { cartTypeToOrderType, shippingMethodsMap, SHIPPING_METHOD_STANDARD } from '../constants';
import { DEFAULT_CART_STRUCTURE } from './structures';
import { getMapKeyByValue } from '../../util/getMapKeyByValue';

export const mapApiToCartStructure = ApiCart => {
  const {
    id,
    cartStatus,
    cartType,
    departmentNumber,
    contactPhoneNumber,
    contactExtension,
    purchaseOrderNumber,
    shippingMethod,
    createdBy,
    createTimestamp,
    updateTimestamp,
    wholesaleTotal,
    userShippingInstructions
  } = ApiCart;

  return {
    ...DEFAULT_CART_STRUCTURE,
    id,
    headers: {
      ...DEFAULT_CART_STRUCTURE.headers,
      cartType,
      orderType: cartTypeToOrderType(cartType), // TODO: Remove this and do all things by cart type
      departmentNumber: String(departmentNumber),
      phoneNumber: contactPhoneNumber || '',
      phoneNumberExt: contactExtension || '',
      purchaseOrderNumber,
      shippingMethod: getMapKeyByValue(shippingMethodsMap, shippingMethod) || SHIPPING_METHOD_STANDARD,
      notesToNike: userShippingInstructions
    },
    status: cartStatus,
    createdBy,
    createdAt: createTimestamp,
    modifiedAt: updateTimestamp || createTimestamp,
    totals: {
      wholesale: wholesaleTotal || 0,
      comp: 0,
      billable: 0,
      unitAllotments: {}
    }
  };
};
